var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"OperateNavTable"},[_c('group',{attrs:{"client":_vm.client,"list":_vm.Table[1],"length":5}}),_c('BoardFast',{attrs:{"client":_vm.client,"group":_vm.TableAll,"step":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }